import React from "react";
import TruncateText from "./TruncateText";

const CoinsCreated = ({ data }) => {
  return (
    <div className="coins-created-container">
      {data.map((coin) => (
        <div className="coins-created-card glass-effect">
          <div className="image-container">
            <img src={coin.image} alt={coin.title} className="image" />
          </div>
          <div className="content">
            <h3>{coin.title}</h3>
            <div className="created-by">
              <div>
                Created by
                <img
                  src={coin.creatorProfileImage}
                  alt=""
                  className="user-profile-image"
                />
                {coin.creator}
              </div>
              <p>{coin.timeAgo}</p>
            </div>
            <p className="market-cap">Market Cap: {coin.marketCap}</p>
            <p className="replies">Replies: {coin.replies}</p>
            <div className="desc">
              <TruncateText maxLength={290} text={coin.description} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CoinsCreated;
